import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { TRANSITIONS } from '../../util/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_CHAT_DATA_REQUEST = 'app/InboxPage/FETCH_CHAT_DATA_REQUEST';
export const FETCH_CHAT_DATA_SUCCESS = 'app/InboxPage/FETCH_CHAT_DATA_SUCCESS';
export const FETCH_CHAT_DATA_ERROR = 'app/InboxPage/FETCH_CHAT_DATA_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  chatDataError: null,
  pagination: null,
  chatData: [],
  pagination: null,
};
export default function MessagePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CHAT_DATA_REQUEST:
      return { ...state, fetchInProgress: true, chatDataError: null };
    case FETCH_CHAT_DATA_SUCCESS: {
      //   console.log(99, payload);
      return {
        ...state,
        fetchInProgress: false,
        chatData: payload,
        // pagination: payload.message.meta,
      };
    }
    case FETCH_CHAT_DATA_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, chatDataError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchChatDataRequest = () => ({ type: FETCH_CHAT_DATA_REQUEST });
const fetchChatDataSuccess = response => ({
  type: FETCH_CHAT_DATA_SUCCESS,
  payload: response,
});
const fetchChatDataError = e => ({
  type: FETCH_CHAT_DATA_ERROR,
  error: true,
  payload: e,
});

export const fetchChatData = () => async (dispatch, getState, sdk) => {
  dispatch(fetchChatDataRequest());

  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const isProvider =
    fetchedcurrentUser && fetchedcurrentUser?.attributes?.profile.publicData.isProvider;
  const isSuperAdmin =
    fetchedcurrentUser && fetchedcurrentUser?.attributes?.profile.publicData.isSuperAdmin;
  const MessageData = await axios.post(`${apiBaseUrl()}/api/user/getMsgTransactions`, {
    userId: fetchedcurrentUser?.id?.uuid,
    isProvider,
    isSuperAdmin,
  });
  // console.log(8888, fetchedcurrentUser, isProvider);
  const messageAndUserData = MessageData.data.map(async m => {
    const message = sdk.messages.query({ transactionId: m.txId });
    const superAdminReplierId =
      fetchedcurrentUser?.id?.uuid === m.workerId ? m.businessId : m.workerId;
    const user = sdk.users.show({
      id: isSuperAdmin ? superAdminReplierId : isProvider ? m.workerId : m.businessId,
      include: ['profile', 'profileImage'],
      'fields.image': [
        // Avatars
        'variants.default',
        'variants.square-small',
        'variants.square-small2x',
      ],
    });
    const [userResp, messageResp] = await Promise.all([user, message]);
    return { message: messageResp.data, user: userResp.data, transactionId: m.txId };
  });
  const myData = Promise.all(messageAndUserData);
  myData
    .then(res => {
      //   console.log(222, res);
      dispatch(fetchChatDataSuccess(res));
    })
    .catch(e => {
      dispatch(fetchChatDataError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  return dispatch(fetchChatData());
};
